import React, { useEffect, useState } from 'react';
import { StyledJobsList } from './StyledJobsList';
import { useLocation,useHistory } from 'react-router-dom';

import {
  setLoader,
} from "../../redux/loader/loader.actions";
import { useDispatch } from "react-redux";

const JobsList = ({ jobs, slug }) => {
  const [displayedArticles, setDisplayedArticles] = useState([])
  const [indexArticles, setIndexArticles] = useState(5)
  const [hideLoadMore, setHideLoadMore] = useState(false)
  const [paginationArray, setPaginationArray] = useState([])
  const [filteredJobs, setFilteredJobs] = useState([]);
  let history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const incrementFactor = 5;
  
  const handleCLick = (slug) => {
    if(history.location.pathname !== slug){
      dispatch(setLoader(true));

      setTimeout(() =>{ 
        document.body.scrollTop = 0;
        history.push(slug)
      }, 500);
    }
  }
 
  const handleLoadMore = () => {
    let allArticles = [...jobs, ...paginationArray]
    let lastIndex = allArticles.length;

    let nextIndex = indexArticles + incrementFactor > lastIndex ? indexArticles + (lastIndex - indexArticles) : indexArticles + incrementFactor;
    let splitNextFive = allArticles.slice(indexArticles, nextIndex)
    
    let indexIncrement = indexArticles + incrementFactor
    setIndexArticles(indexIncrement)
    
    var newArray = [...displayedArticles, ...splitNextFive ]
    
    setDisplayedArticles(newArray);
    
    
  }

  useEffect(()=>{
    const filtered = jobs.filter( job =>  job.slug !== slug);
    setHideLoadMore(jobs.length <= incrementFactor);
    setDisplayedArticles(jobs.slice(0, indexArticles))

    setFilteredJobs(filtered )

  },[])
  return (
    <React.Fragment>
      {
        
       
          <StyledJobsList>
            {
              filteredJobs.length > 0 &&
              <>
              <h6 className="md--title list-title">Open roles</h6>
              
              <div className="jobs-column">
                <div className="job-row header-row">
                  <div className="job-cell">
                    <p className="preset-13">ROLE</p>
                  </div>
                  <div className="job-cell">
                    <p className="preset-13">LOCATION</p>
                  </div>
                  <div className="job-cell"></div>
                </div>
                {
                  filteredJobs.map((key, index) => {
                    return  <div className="job-row" key={index}>
                              <div className="job-cell">
                                <h4 className="md--title">{key.job_title}</h4>
                              </div>
                              <div className="job-cell">
                                <p className="preset-11">{key.location}</p>
                              </div>
                              <div className="job-cell">
                                <div className="cta--primary cursor-cta" onClick={()=> handleCLick(`/careers/${key.slug}`)}>
                                  <p className="preset-10 cursor-cta" style={{color: '#45B865'}} >Go to job description</p>
                                    <svg width="14" className="next cursor-cta" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path className="cursor-cta" d="M7.66675 10.6673L13.0001 6.00065L7.66675 1.33398" stroke={'#45B865'} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                                      <path className="cursor-cta" d="M13 6H1" stroke={'#45B865'} strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </div>
                              </div>
                            </div>
                  })
                }
                {
                  !hideLoadMore &&
                  <div className="load-btn" onClick={() => handleLoadMore()}>
                    <p className="preset-10">Load more</p>
                    <img src="/rotate.svg" />
                  </div>
                }
              </div>    
              </>  
            } 
          </StyledJobsList>
          
      }
    </React.Fragment>
  );
};

export default JobsList;
